import { useMemo } from 'react';

// Utils
import { detectSubdomain } from 'utils/subdomain-helpers';


/**
 * Custom hook to detect if the current page is on a subdomain
 * Uses window.location.hostname since Next.js router doesn't provide hostname
 * Memoized to prevent unnecessary recalculations
 * @returns {string|null} The subdomain name or null if on main domain
 */
const useSubdomain = () => {
  const subdomain = useMemo(() => {
    // Server-side: cannot determine subdomain client-side
    if (typeof window === 'undefined') {
      return null;
    }

    // Note: We use window.location.hostname because Next.js router
    // doesn't expose hostname information. This is the standard approach
    // used in Next.js apps, including Vercel's official multi-tenant examples.
    const { hostname } = window.location;

    return detectSubdomain(hostname);
  }, []); // Empty deps: hostname doesn't change during SPA navigation

  return subdomain;
};

export default useSubdomain;
